module.exports = __webpack_public_path__ + "img/main_mobile.df9ec905.gif";